import { useNow } from '@griply/hooks';
import {
  getExternalEventTimeLabel,
  hasExternalCalendarEventEnded,
} from '@griply/utils';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { TimeFormatOptions } from 'shared/types/date-format-options';
import { ExternalCalendarEvent } from 'shared/types/external-calendar-event';

import { ExternalEventRow } from './external-event-row';
import * as Styled from './external-events-list.style';

export type ExternalEventsListProps = {
  events: ExternalCalendarEvent[];
  show?: boolean;
  spaceAbove?: boolean;
  timeFormat: TimeFormatOptions;
};

export const ExternalEventsList: React.FC<ExternalEventsListProps> = ({
  events,
  show = true,
  spaceAbove = false,
  timeFormat,
}) => {
  const { t } = useTranslation();
  const now = useNow();

  return (
    <Styled.Container
      $show={show}
      $items={events.length}
      $spaceAbove={spaceAbove}
    >
      <Styled.List>
        {events.map((event) => {
          const timeLabel = getExternalEventTimeLabel(event, timeFormat);
          const label = timeLabel.isAllDay
            ? t('general.labels.all-day')
            : timeLabel.range;

          return (
            <ExternalEventRow
              key={event.id}
              event={event}
              label={label}
              isPast={hasExternalCalendarEventEnded(event, now)}
            />
          );
        })}
      </Styled.List>
    </Styled.Container>
  );
};
